import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/office/orders/")({
  beforeLoad: async () => {
    throw redirect({
      to: "/office/orders/active",
    });
  },
});
